<template>
  <div class="popup-timer-paused">
    <div class="left">
      <UIButton
        v-if="!isOrganizationEducation"
        icon="clock"
        :ghost="true"
        class="paidextension"
        @click="$emit('openPaidExtension')"
      >{{ $t('Paid Extension') }}</UIButton>
      <UIButton
        :ghost="true"
        class="editstation"
        @click="$emit('editBooking')"
      >{{ $t("Edit Reservation") }}</UIButton>
    </div>
    <div class="right">
      <UIButton icon="play" @click="resume" class="resume">{{ $t('Resume') }}</UIButton>
      <div class="inputs">
        <UIInput type="number" :instructions="$t('Hour')" min="0" max="99" v-model="time.hour" />
        <UIInput type="number" :instructions="$t('Minute')" min="0" max="99" v-model="time.minute" />
        <UIInput type="number" :instructions="$t('Second')" min="0" max="99" v-model="time.second" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment-timezone';
import DateHelper from '@/core/shared/helpers/DateHelper';
import UIButton from '@/core/shared/components/ui/UIButton';
import UIInput from '@/core/shared/components/ui/UIInput';

@Component({
  components: {
    UIButton,
    UIInput,
  },
  props: {
    endTime: {
      type: String,
      required: true,
    },
    currentTime: {
      type: String,
      required: true,
    },
    isOrganizationEducation: {
      type: Boolean,
      default: false,
    },
  },
})
export default class BookingDetailTimerPaused extends Vue {
  time = {
    hour: null,
    minute: null,
    second: null,
  };

  mounted () {
    const diff = moment(this.endTime).diff(moment(this.currentTime));
    const time = DateHelper.formatMillisecondsToHMS(diff);
    const parts = time.split(':');

    if (time.length > 5) {
      this.time.hour = parts[0];
      this.time.minute = parts[1];
      this.time.second = parts[2];
    } else {
      this.time.minute = parts[0];
      this.time.second = parts[1];
    }
  }

  resume () {
    let secondsFromNow = 0;
    if (this.time.hour) secondsFromNow += parseInt(this.time.hour) * 3600;
    if (this.time.minute) secondsFromNow += parseInt(this.time.minute) * 60;
    if (this.time.second) secondsFromNow += parseInt(this.time.second);
    this.$emit('resume', secondsFromNow);
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.popup-timer-paused {
  @media (--tablet) {
    display: flex;
    align-items: flex-start;
    padding: 0;
  }

  & .left {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    padding: var(--spacingSm) 0 0 0;

    @media (--tablet) {
      border-left: 0.1rem solid var(--colorCasper);
      padding: var(--spacingSm) var(--spacingMd);
    }

    & .paidextension {
      flex: 1 1 auto;
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: var(--spacingSm);

      & svg {
        fill: var(--colorGeyser);
        width: 1.6rem;
        height: 1.6rem;
        margin-right: var(--spacingSm);
      }
    }

    & .editstation {
      flex: 1 1 auto;
      width: auto;
    }
  }

  & .right {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: flex-end;
    padding: var(--spacingSm) 0;

    @media (--tablet) {
      border-left: 0.1rem solid var(--colorCasper);
      padding: var(--spacingSm) var(--spacingMd);
    }

    & .resume {
      flex: 1 1 auto;
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: var(--spacingSm);
      align-self: flex-start;
      background: var(--colorSuccess);

      & svg {
        fill: var(--colorWhite);
        height: 1.6rem;
        width: 1.6rem;
        margin-right: var(--spacingSm);
      }
    }

    & .inputs {
      display: flex;
      align-items: center;

      & > * {
        margin-right: var(--spacingXS);
      }

      & >>> input {
        display: block;
        width: 5rem;
        padding: calc(var(--spacingXS) - 0.4rem);

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
